<template>
    <ul class="facets-list-type-1">
        <li v-for="(item, index) in buckets" :key="index" class="item">
            <div class="name" v-if="slug === 'employees' || slug === 'revenue'">
                <template v-if="item.val === -1">{{ $t(`components.dataset_specification.${slug}.unknown`) }}</template>
                <template v-else-if="isMinOnly(item.text)">{{ $t(`components.dataset_specification.${slug}.min`, { min: slug === 'revenue' ? formatNumber(getMin(item.text), '€') : formatNumber(getMin(item.text)) }) }}</template>
                <template v-else-if="isMaxOnly(item.text)">{{ $t(`components.dataset_specification.${slug}.max`, { max: slug === 'revenue' ? formatNumber(getMax(item.text), '€') : formatNumber(getMax(item.text)) }) }}</template>
                <template v-else-if="isRange(item.text)">{{ $t(`components.dataset_specification.${slug}.range`, { min: slug === 'revenue' ? formatNumber(getMin(item.text), '€') : formatNumber(getMin(item.text)), max: slug === 'revenue' ? formatNumber(getMax(item.text), '€') : formatNumber(getMax(item.text)) }) }}</template>
                <template v-else>{{ item.displayName || item.text || item.val }}</template>
            </div>
            <div class="name" v-else>{{ item.displayName || item.text || item.val }}</div>
            <div class="value">{{ formatNumber(item.count) }}</div>
        </li>
    </ul>
</template>

<script>
    import { formatNumber } from '@/utils/formatting';
    export default {
        name: 'FacetsList',
        props: {
            buckets: {
                type: Array,
                required: true
            },
            slug: {
                type: String,
                required: false
            }
        },
        methods: {
            formatNumber,
            isMinOnly(text) {
                return text && text.includes(':') && text.endsWith(':');
            },
            isMaxOnly(text) {
                return text && text.includes(':') && text.startsWith(':');
            },
            isRange(text) {
                return text && text.includes(':') && !this.isMinOnly(text) && !this.isMaxOnly(text);
            },
            getMin(text) {
                if (!text || !text.includes(':')) return '';
                const parts = text.split(':');
                return this.isMaxOnly(text) ? '' : parts[0];
            },
            getMax(text) {
                if (!text || !text.includes(':')) return '';
                const parts = text.split(':');
                return this.isMinOnly(text) ? '' : parts[1];
            }
        }
    }
</script>